import {setUpAlerting} from '@malt/alerting';

Hop.defineModule('alerting-service', (root, {configuration, application, connectedUser}) => {
    const config = {
        configuration,
        application,
    };

    if (connectedUser) {
        config.connectedUser = connectedUser;
    }
    setUpAlerting(config);
});
